import { useEffect, useState } from "react";
import { getDeviceInfo, type DeviceInfo } from "hub/src/utils/getDeviceInfo";

const useDeviceInfo = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>(getDeviceInfo);

  useEffect(() => {
    setDeviceInfo(getDeviceInfo());
  }, []);

  return deviceInfo;
};

export default useDeviceInfo;
